import { UserDefaults } from 'store/defaults';
import UserPartition from './user.partition';

/**
 * Redux Actions Reducer.
 *
 * @param {any} store current store partition state.
 * @param {any} action action dispatched.
 *
 * @returns {any} new state or store partition.
 */
export default function UserReducer(store = UserDefaults, action)
{
    const { type, payload } = action;

    switch (type)
    {
        // executes the action.
        case UserPartition.Type.EXEC:
            delete store.error;

            return {
                ...store,
                state: UserPartition.State.EXECUTING,
                data: payload
            };

        // action is successful.
        case UserPartition.Type.COMMIT:
            return {
                ...store,
                state: UserPartition.State.READY
            };

        // action was finished with errors.
        case UserPartition.Type.ROLLBACK:
            return {
                ...store,
                state: UserPartition.State.FAILED,
                error: payload
            };

        // default doesn't changes the store,
        // so, components won't re-renders.
        default:
            return store;
    }
}
